var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getData } from './api';
import api from './api';
export var ticketsService = {
    getTickets: function (filters) {
        if (filters === void 0) { filters = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, page, otherFilters, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = filters.page, page = _a === void 0 ? 1 : _a, otherFilters = __rest(filters, ["page"]);
                        return [4 /*yield*/, getData('tickets', __assign({ page: page }, otherFilters))];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    },
    getTicket: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getData("tickets/" + id)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); },
    updateTicket: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var id, updateData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = params.id, updateData = __rest(params, ["id"]);
                    return [4 /*yield*/, api.put("/tickets/" + id, {
                            ticket: updateData,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    completeTicket: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var id, _a, notify_client, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    id = params.id, _a = params.notify_client, notify_client = _a === void 0 ? false : _a;
                    return [4 /*yield*/, api.post("/tickets/" + id + "/complete", {
                            ticket: { notify_client: notify_client },
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketArrangements: function (ticketId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getData("tickets/" + ticketId + "/arrangements")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); },
    createArrangement: function (ticketId, params) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    formData.append('arrangement[arrangement_type]', params.arrangement_type);
                    if (params.authorized_by_id) {
                        formData.append('arrangement[authorized_by_id]', params.authorized_by_id.toString());
                    }
                    if (params.provider_id) {
                        formData.append('arrangement[provider_id]', params.provider_id.toString());
                    }
                    if (params.budget_request_id) {
                        formData.append('arrangement[budget_request_id]', params.budget_request_id.toString());
                    }
                    if (params.internal_comment) {
                        formData.append('arrangement[internal_comment]', params.internal_comment);
                    }
                    if (params.files && params.files.length > 0) {
                        params.files.forEach(function (file) {
                            formData.append('arrangement[files][]', file);
                        });
                    }
                    if (params.mentioned_admin_user_ids && params.mentioned_admin_user_ids.length > 0) {
                        params.mentioned_admin_user_ids.forEach(function (mentionedAdminUserId) {
                            formData.append('arrangement[mentioned_admin_user_ids][]', mentionedAdminUserId.toString());
                        });
                    }
                    return [4 /*yield*/, api.post("/tickets/" + ticketId + "/arrangements", formData, {
                            headers: { 'Content-Type': 'multipart/form-data' },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketComments: function (ticketId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getData("tickets/" + ticketId + "/comments")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); },
    createComment: function (ticketId, params) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    formData.append('comment[content]', params.content);
                    if (params.files && params.files.length > 0) {
                        params.files.forEach(function (file) {
                            formData.append('comment[files][]', file);
                        });
                    }
                    if (params.mentioned_admin_user_ids && params.mentioned_admin_user_ids.length > 0) {
                        params.mentioned_admin_user_ids.forEach(function (mentionedAdminUserId) {
                            formData.append('comment[mentioned_admin_user_ids][]', mentionedAdminUserId.toString());
                        });
                    }
                    return [4 /*yield*/, api.post("/tickets/" + ticketId + "/comments", formData, {
                            headers: { 'Content-Type': 'multipart/form-data' },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketAuditLogs: function (ticketId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/tickets/" + ticketId + "/audits")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.audits];
            }
        });
    }); },
    getTicketAlerts: function (buildingId, params) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.get("/buildings/" + buildingId + "/ticket_alerts", {
                        params: {
                            order_by: (_a = params.order) === null || _a === void 0 ? void 0 : _a.order_by,
                            direction: (_b = params.order) === null || _b === void 0 ? void 0 : _b.direction,
                            page: params.page,
                        },
                    })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getBuildingGenericAlerts: function (buildingId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/buildings/" + buildingId + "/ticket_alerts", {
                        params: {
                            apartment_id: '',
                            pagination: 'false',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getApartmentAlerts: function (buildingId, apartmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/buildings/" + buildingId + "/ticket_alerts", {
                        params: {
                            apartment_id: apartmentId.toString(),
                            pagination: 'false',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketAlert: function (buildingId, ticketAlertId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/buildings/" + buildingId + "/ticket_alerts/" + ticketAlertId)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    createTicketAlert: function (buildingId, createData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/buildings/" + buildingId + "/ticket_alerts", createData)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    updateTicketAlert: function (buildingId, ticketAlertId, updateData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.put("/buildings/" + buildingId + "/ticket_alerts/" + ticketAlertId, updateData)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    deleteTicketAlert: function (buildingId, ticketAlertId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/buildings/" + buildingId + "/ticket_alerts/" + ticketAlertId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    getArrangements: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, api.get('/arrangements', {
                        params: {
                            type: params.type,
                            provider_id: (_a = params.provider_id) !== null && _a !== void 0 ? _a : undefined,
                            building_id: (_b = params.building_id) !== null && _b !== void 0 ? _b : undefined,
                            order_by: (_c = params.order) === null || _c === void 0 ? void 0 : _c.order_by,
                            direction: (_d = params.order) === null || _d === void 0 ? void 0 : _d.direction,
                            page: params.page,
                        },
                    })];
                case 1:
                    response = _e.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketReminders: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/ticket_reminders", {
                        params: params,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getTicketReminderTicketOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get('/tickets/dropdown')];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.tickets];
            }
        });
    }); },
    getTicketReminder: function (ticketReminderId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/ticket_reminders/" + ticketReminderId)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    createTicketReminder: function (createData) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/ticket_reminders", createData)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    updateTicketReminder: function (ticketReminderId, updateData) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.put("/ticket_reminders/" + ticketReminderId, updateData)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    deleteTicketReminder: function (ticketReminderId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/ticket_reminders/" + ticketReminderId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
};
